/*
 * Noxer : fiche produit (ajouts au thème Savor 4.1.5)
 * - Fenêtre « Guide des tailles » : ouverture, fermeture (croix, Échap, clic sur le fond),
 *   focus piégé, retour du focus sur le lien, page bloquée derrière, taille choisie mise en avant.
 * - Compteur de la galerie : texte lu par les lecteurs d'écran (« Photo 1 sur 12 »).
 * Chargé en différé par snippets/noxer-product-assets.liquid. Aucune dépendance.
 */
(function () {
  'use strict';

  var DIALOG_ID = 'NoxerSizeGuide';
  var OPEN_SELECTOR = '[data-noxer-size-guide-open]';
  var CLOSE_SELECTOR = '[data-noxer-size-guide-close]';
  var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])';
  var lastTrigger = null;

  /* ---------------- Guide des tailles ---------------- */

  function getDialog() {
    return document.getElementById(DIALOG_ID);
  }

  function getSelectedSize() {
    var pickers = document.querySelectorAll('variant-picker[data-template-product-match="true"], variant-picker');
    for (var i = 0; i < pickers.length; i++) {
      var inputs = pickers[i].querySelectorAll('input[type="radio"]:checked');
      for (var j = 0; j < inputs.length; j++) {
        var name = (inputs[j].getAttribute('data-option-name') || '').trim().toLowerCase();
        if (name === 'taille' || name === 'size') return inputs[j].value;
      }
    }
    return null;
  }

  function highlightSelectedSize(dialog) {
    var size = getSelectedSize();
    var rows = dialog.querySelectorAll('tr[data-size]');
    for (var i = 0; i < rows.length; i++) {
      var isSelected = size !== null && rows[i].getAttribute('data-size') === size;
      rows[i].classList.toggle('is-selected', isSelected);
      if (isSelected) {
        rows[i].setAttribute('aria-current', 'true');
      } else {
        rows[i].removeAttribute('aria-current');
      }
    }
  }

  function getFocusable(dialog) {
    var nodes = dialog.querySelectorAll(FOCUSABLE);
    var list = [];
    for (var i = 0; i < nodes.length; i++) {
      if (nodes[i].getClientRects().length > 0) list.push(nodes[i]);
    }
    return list;
  }

  function closeDialog(dialog) {
    if (!dialog) return;
    if (typeof dialog.close === 'function' && dialog.open) {
      dialog.close();
    } else if (dialog.hasAttribute('open')) {
      dialog.removeAttribute('open');
      onDialogClosed();
    }
  }

  function onDialogClosed() {
    document.documentElement.classList.remove('noxer-scroll-lock');

    var target = lastTrigger;
    if (!target || !document.contains(target)) {
      // Le sélecteur de variantes a pu être re-rendu : on reprend le lien actuel.
      target = document.querySelector(OPEN_SELECTOR);
    }
    if (target) {
      target.setAttribute('aria-expanded', 'false');
      target.focus();
    }
    lastTrigger = null;
  }

  function bindDialog(dialog) {
    if (dialog.getAttribute('data-noxer-bound') === 'true') return;
    dialog.setAttribute('data-noxer-bound', 'true');

    // Fermeture native (Échap ou dialog.close()).
    dialog.addEventListener('close', onDialogClosed);

    // Clic sur le fond : la cible est la balise <dialog> elle-même (le contenu est dans __inner).
    dialog.addEventListener('click', function (event) {
      if (event.target === dialog) closeDialog(dialog);
    });

    dialog.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && typeof dialog.showModal !== 'function') {
        event.preventDefault();
        closeDialog(dialog);
        return;
      }
      if (event.key !== 'Tab') return;

      // Focus piégé dans la fenêtre (Tab / Maj+Tab).
      var items = getFocusable(dialog);
      if (items.length === 0) {
        event.preventDefault();
        return;
      }
      var first = items[0];
      var last = items[items.length - 1];
      var active = document.activeElement;
      var inList = items.indexOf(active) !== -1;

      if (event.shiftKey && (active === first || !inList)) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && (active === last || !inList)) {
        event.preventDefault();
        first.focus();
      }
    });
  }

  function openDialog(trigger) {
    var dialog = getDialog();
    if (!dialog || dialog.open) return;

    bindDialog(dialog);
    highlightSelectedSize(dialog);
    lastTrigger = trigger || null;

    if (typeof dialog.showModal === 'function') {
      dialog.showModal();
    } else {
      dialog.setAttribute('open', '');
    }

    document.documentElement.classList.add('noxer-scroll-lock');
    if (trigger) trigger.setAttribute('aria-expanded', 'true');

    var closeButton = dialog.querySelector(CLOSE_SELECTOR);
    if (closeButton) closeButton.focus();
  }

  // Délégation : le lien est dans le sélecteur de variantes, re-rendu par le thème à chaque changement.
  document.addEventListener('click', function (event) {
    if (!(event.target instanceof Element)) return;

    var trigger = event.target.closest(OPEN_SELECTOR);
    if (trigger) {
      event.preventDefault();
      openDialog(trigger);
      return;
    }

    var closer = event.target.closest(CLOSE_SELECTOR);
    if (closer) {
      event.preventDefault();
      closeDialog(closer.closest('dialog'));
    }
  });

  /* ---------------- Compteur de la galerie ---------------- */

  function enhanceCounters(root) {
    var counters = root.querySelectorAll('media-gallery .slideshow-controls__counter');
    for (var i = 0; i < counters.length; i++) {
      enhanceCounter(counters[i]);
    }
  }

  function enhanceCounter(counter) {
    if (counter.getAttribute('data-noxer-a11y') === 'true') return;

    var current = counter.querySelector('[ref="current"]');
    var parts = (counter.textContent || '').split('/');
    var total = parts.length > 1 ? parts[1].trim() : '';
    if (!current || !total) return;

    counter.setAttribute('data-noxer-a11y', 'true');
    counter.setAttribute('aria-hidden', 'true');

    var label = document.createElement('span');
    label.className = 'visually-hidden';
    counter.insertAdjacentElement('afterend', label);

    var update = function () {
      label.textContent = 'Photo ' + current.textContent.trim() + ' sur ' + total;
    };
    update();

    new MutationObserver(update).observe(current, { childList: true, characterData: true, subtree: true });
  }

  function watchGalleries() {
    enhanceCounters(document);

    var galleries = document.querySelectorAll('media-gallery');
    for (var i = 0; i < galleries.length; i++) {
      // La galerie est re-rendue quand on change de couleur : on ré-applique.
      new MutationObserver(function (mutations) {
        for (var k = 0; k < mutations.length; k++) {
          if (mutations[k].addedNodes.length) {
            enhanceCounters(document);
            return;
          }
        }
      }).observe(galleries[i], { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watchGalleries);
  } else {
    watchGalleries();
  }
})();
